import React from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import {
  Reports,
  ReportsConsulta,
  ReportsOutputsCache,
  ReportSettings,
  ReportSettingsAdd,
  ReportSettingsEdit,
  ReportSettingsRegras,
  ReportSettingsBenchmarks,
} from "../../../pages";
import RelatorioProvider from "../../../contexts/RelatorioContext";
import { OUTPUT } from "../../../enums";
import useAcesso from "../../../hooks/useAcesso";

const ReportsRoutes = () => {
  const location = useLocation();
  const { canAcessar } = useAcesso();

  // Utiliza o hook useAcesso para obter a função canAcessar, que será usada para verificar as permissões de acesso do usuário ao relatório.
  //
  // Com base na rota atual (location.pathname), extraímos qual é o tipo de output selecionado pelo usuário na tela.
  // A partir desse output, recuperamos sua chave de acesso (output_id) definida no enum OUTPUT.
  // Em seguida, verificamos se o usuário possui permissão mínima de consulta para esse tipo de relatório.
  // Caso não tenha permissão, o usuário é redirecionado para o dashboard.
  const xMatchOutput = location.pathname.match(/\/reports\/([^/]+)/);
  const xOutput = xMatchOutput ? xMatchOutput[1] : null;
  const xOutputId = OUTPUT[xOutput]?.output_id;

  if (xOutputId && !canAcessar(xOutputId)) {
    return <Navigate to="/dashboard" replace={true} />;
  }

  return (
    <RelatorioProvider>
      <Routes>
        <Route
          path={":output/configuracoes/:id"}
          element={<ReportSettingsRegras />}
        />
        <Route
          path={":output/configuracoes/benchmarks"}
          element={<ReportSettingsBenchmarks />}
        />
        <Route
          path={":output/configuracoes/add"}
          element={<ReportSettingsAdd />}
        />
        <Route
          path={":output/configuracoes/edit"}
          element={<ReportSettingsEdit />}
        />
        <Route path={":output/configuracoes"} element={<ReportSettings />} />
        <Route path={":output/:id/*"} element={<ReportsConsulta />} />
        <Route path={":output/*"} element={<ReportsOutputsCache />} />
        <Route path={"*"} element={<Reports />} />
      </Routes>
    </RelatorioProvider>
  );
};

export default ReportsRoutes;
